import { render, staticRenderFns } from "./AsideOfMain.vue?vue&type=template&id=fcae34f0&scoped=true&v-if=showBusy"
import script from "./AsideOfMain.vue?vue&type=script&lang=js"
export * from "./AsideOfMain.vue?vue&type=script&lang=js"
import style0 from "./AsideOfMain.vue?vue&type=style&index=0&id=fcae34f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcae34f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/src/Web/InternetBranch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcae34f0')) {
      api.createRecord('fcae34f0', component.options)
    } else {
      api.reload('fcae34f0', component.options)
    }
    module.hot.accept("./AsideOfMain.vue?vue&type=template&id=fcae34f0&scoped=true&v-if=showBusy", function () {
      api.rerender('fcae34f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsideOfMain.vue"
export default component.exports